import { FC } from 'react';

interface LoaderProps {
    className: String;
}
export const Loader: FC<LoaderProps> = ({ className = '' }) => <div className={"loader " + className}>Loading...</div>;
